import axios from 'axios';
import { request } from '../../helpers/requests';

const EmailSubscriptionService = {
  getUnsubscribed: () => request({
    call: axios.get('emails/unsubscribed'),
    errMsg: 'Failed to get unsubscribed emails',
    hideSuccessToast: true,
  }),
  resubscribe: (id, password) => request({
    call: axios.put(`emails/${id}/resubscribe`, { password }),
    errMsg: 'Failed to resubscribe recipient',
    successMsg: 'Recipient resubscribed successfully',
  }),
};

export default EmailSubscriptionService;
